import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/", { replace: true }); return; }
      const sessionId = decodeURIComponent(m[1]);
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // Clean URL hash
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Не вдалося завершити вхід через Google. Спробуйте ще раз.");
        setTimeout(() => navigate("/", { replace: true }), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-onyx">
      <div className="text-center">
        <div className="font-display italic-display text-5xl text-brass">Д</div>
        <div className="text-bone/60 text-sm tracking-[0.2em] uppercase mt-4">{error || "Завершуємо вхід…"}</div>
      </div>
    </div>
  );
}
